import * as React from 'react'
import { AutoCompleteInput, Button, Checkbox, ColorPicker, IconButton, Input, Label, NotificationBlock, Select } from 'uxp/components'
import ActionEditorLink, { extractAction, IAction } from '../action-editor/ActionEditor'
import { applyAtPath, IBaseProperty, IUIPropertyDefinition } from '../common'
import { BackgroundPositionEditor, CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle, TextAlignEditor } from './common'
import { IBackgroundProps, ITextProps } from './properties'
import jp from 'jsonpath'
import { hasProperty, hasValue } from '../../../util'
import { sortBy } from 'lodash-es'
import { $L } from '../../../localize';

export interface IChartDataSortingProperty extends IBaseProperty {
    sortBy: 'none' | 'label' | 'value',
    sortOrder: 'asc' | 'desc'
    isTimeSeriesData: boolean
}

export interface SortConfig {
    sortBy: 'none' | 'label' | 'value',
    sortOrder: 'asc' | 'desc'
}
export function extractChartDataSortConfig(props: IChartDataSortingProperty): SortConfig {
    if (props?.isTimeSeriesData) return { sortBy: 'label', sortOrder: 'asc' }
    else return { sortBy: props?.sortBy || 'none', sortOrder: props?.sortOrder || 'asc' }
}

export function ChartDataSortingProperty(defaultProps: IChartDataSortingProperty, title?: string,): IUIPropertyDefinition<IChartDataSortingProperty> {
    return {
        defaults: defaultProps,
        render: (props, uxpContext, data, containerId) => {

            let _props = props?.uiProps || { sortBy: 'none', sortOrder: 'asc', isTimeSeriesData: false }
            containerId = hasValue(containerId) ? containerId + '-' : ''

            return <PropertyContainer>
                <PropertyContainerTitle>{title || $L('widgetdesigner.props.chart-data-sorting', 'Chart data sorting')}</PropertyContainerTitle>
                <PropertyGroup>
                    {/* <PropertyGroupTitle>{'X Axis Label'}</PropertyGroupTitle> */}
                    {
                        (_props.isTimeSeriesData) ? <>
                            <NotificationBlock message='Data will be sorted by the datetime' />
                        </>
                            :
                            <>
                                <Property id={containerId + 'sort-by'} >
                                    <PropertyTitle>{$L('widgetdesigner.props.sort-by', 'SortBy')}</PropertyTitle>
                                    <Select
                                        selected={_props.sortBy || 'none'}
                                        onChange={s => {
                                            let newProps = applyAtPath(_props, '$.sortBy', () => (s))
                                            props.onChange(newProps)
                                        }}
                                        options={[
                                            { label: $L('widgetdesigner.props.none', 'None'), value: 'none' },
                                            { label: $L('widgetdesigner.props.value-y-axis', 'Value (Y axis)'), value: 'value' },
                                            { label: $L('widgetdesigner.props.label-x-axis', 'Label (X axis)'), value: 'label' },
                                        ]}
                                        className="widget-designer-input"
                                    />
                                </Property>

                                <Property id={containerId + 'sort-order'} >
                                    <PropertyTitle>{$L('widgetdesigner.props.sort-direction', 'Sort direction')}</PropertyTitle>
                                    <Select
                                        selected={_props.sortOrder || 'asc'}
                                        onChange={s => {
                                            let newProps = applyAtPath(_props, '$.sortOrder', () => (s))
                                            props.onChange(newProps)
                                        }}
                                        options={[
                                            { label: $L('widgetdesigner.props.ascending', 'Ascending'), value: 'asc' },
                                            { label: $L('widgetdesigner.props.descending', 'Descending'), value: 'desc' },
                                        ]}
                                        className="widget-designer-input"
                                    />
                                </Property>
                            </>
                    }
                </PropertyGroup>
            </PropertyContainer>
        }
    }

}